<boi-validation-error [propertyNames]="propertyNames"></boi-validation-error>
<kendo-textbox-container class="form-element">
  <div class="form-label" [boiRequiredFormField]="labelName">
    <label [innerHtml]="labelName |
                        localizeLabel"></label>
  </div>
  <div class="form-input-container">
    <label class="mr-30" *ngFor="let option of optionList">
      <input [name]="controlId ? controlId : labelName" type="radio" class="k-radio" [(ngModel)]="value"
        (ngModelChange)="valueChange.emit(value)" [value]="option.ID" [disabled]="isFieldDisabled" />
      <span class="k-radio-label">{{option.Value}}</span>
    </label>
  </div>
</kendo-textbox-container>
